import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import * as ReferenceObjectTypes from 'reference-resolvers/constants/ReferenceObjectTypes';
import { STRING } from 'customer-data-objects/property/PropertyTypes';
import { NONE } from 'customer-data-filters-ui/filterQueryFormat/timestamps/TimestampTypes';
import { DSAssetFamilyToReferenceObjectType, resolversMap } from '../constants/resolversMap';
import { isReferenceResolverSearch } from '../../../types/ReferenceResolver';
import { List, Map as ImmutableMap } from 'immutable';
import { atomToPromise } from '../../../utils/atomToPromise';
import { getDynamicFilterFamilyBasis, parseDynamicFilterFamilyId, testDynamicFilterFamily } from '../../../filterQueryFormat/DynamicFilterFamilies';
import { toDSFieldRecord } from '../../../public/core';
import Adapter from './Adapter';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
import MissingField from '../../../filterQueryFormat/MissingField';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
import Raven from 'raven-js';
import get from 'transmute/get';
import identity from 'transmute/identity';
import indexBy from 'transmute/indexBy';
import memoize from 'transmute/memoize';
import { conditionsGrouping } from '../../../utils/addingCondition';
import { isEventBasedFilterFamily } from '../../../strategy/eventBasedFilters';
const lastQueries = {};
const isQueryChanged = (query, lastQuery) => (!!query || !!lastQuery) && query !== lastQuery;
const getLastQuery = (referenceObjectType, resolver) => {
  if (isReferenceResolverSearch(resolver)) {
    return lastQueries[referenceObjectType];
  }
  return undefined;
};
const resetLastQueries = referenceObjectType => {
  delete lastQueries[referenceObjectType];
};
export const resetLastQueriesAll = () => {
  Object.keys(lastQueries).forEach(key => delete lastQueries[key]);
};
const getMissingFields = (assetFamily, data, getMissingFieldErrorMessage, requiredIds = []) => {
  if (assetFamily === DSAssetFamilies.INTEGRATION_PROPERTY) {
    return ImmutableMap();
  }
  const missingFields = requiredIds.reduce((acc, id) => {
    if (!data.has(id)) {
      return acc.set(id, MissingField({
        label: id,
        name: id,
        type: STRING,
        timestampType: NONE
      }));
    }
    return acc;
  }, ImmutableMap());
  return getMissingFieldErrorMessage ? missingFields.map(field => field.set('errorMessage', getMissingFieldErrorMessage())) : missingFields;
};
const getFetchVariables = (assetFamily, variables) => {
  const allVariables = Object.assign({}, variables);
  if (testDynamicFilterFamily(DSAssetFamilies.IN_LIST, assetFamily)) {
    allVariables.listFilterProperties = {
      objectTypeId: parseDynamicFilterFamilyId(DSAssetFamilies.IN_LIST, assetFamily),
      includeDeletes: false
    };
  }
  return allVariables;
};
const INTEGRATION_DATE = 'Date';
const INTEGRATION_DATE_TIME = 'DateTime';
export const getDataWithMutations = (data, assetFamily) => {
  if (assetFamily === DSAssetFamilies.INTEGRATION_PROPERTY) {
    return data.map(entry => {
      const properties = entry.getIn(['referencedObject', 'properties']);
      const adjustedProperties = properties.map(p => {
        // Integration dates are stored as DateTimes but the service labels them as Date
        // We need to overwrite the type to ensure the right behavior
        if (p.get('propertyType') === INTEGRATION_DATE) {
          return p.set('propertyType', INTEGRATION_DATE_TIME);
        }
        return p;
      });
      return entry.setIn(['referencedObject', 'properties'], adjustedProperties);
    });
  }
  return data;
};
export class ReferenceResolverAdapterConfig {
  constructor() {
    this.performanceTrackingKey = 'ReferenceResolverAdapter';
  }
  isAssetFamilySupported(assetFamily) {
    const assetFamilyBasis = getDynamicFilterFamilyBasis(assetFamily);
    return DSAssetFamilyToReferenceObjectType.has(assetFamilyBasis || assetFamily);
  }
  getFetcher(assetFamily, props) {
    const {
      referenceResolversByDSAssetFamily = {}
    } = props;
    if (testDynamicFilterFamily(DSAssetFamilies.IN_LIST, assetFamily)) {
      return referenceResolversByDSAssetFamily[DSAssetFamilies.IN_LIST];
    }
    return referenceResolversByDSAssetFamily[assetFamily];
  }
  fetchData(resolver, assetFamily, variables) {
    const {
      getMissingFieldErrorMessage,
      ids,
      hasMore,
      offset,
      query,
      listFilterProperties
    } = getFetchVariables(assetFamily, variables);
    const referenceObjectType = DSAssetFamilyToReferenceObjectType.get(assetFamily);
    const lastQuery = getLastQuery(referenceObjectType, resolver);
    const queryChanged = isQueryChanged(query, lastQuery);
    const actualOffset = queryChanged ? 0 : offset;
    const actualHasMore = queryChanged || hasMore;
    const fetchDataHandler = newAssets => {
      const isPaginated = isReferenceResolverSearch(resolver);
      if (ids && isPaginated && Array.isArray(newAssets)) {
        if (ids.length === 0) {
          return {
            data: ImmutableMap(),
            hasMore,
            offset
          };
        }
        const data = indexBy(
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '<T extends object | Iterable<any... Remove this comment to see the full error message
        get('id'), List(newAssets)).filter(newAsset => !!newAsset);
        const missingData = getMissingFields(assetFamily, data, getMissingFieldErrorMessage, ids);
        const isHiddenFromSelect = referenceObjectType !== ReferenceObjectTypes.INTEGRATION_PROPERTY && !conditionsGrouping.isAssetMembershipFilterFamily(assetFamily) && !isEventBasedFilterFamily(assetFamily);
        return {
          data,
          hasMore,
          isHiddenFromSelect,
          missingData,
          offset
        };
      }
      lastQueries[referenceObjectType] = query;

      // @ts-expect-error `newAssets` is unknown
      const parsedAssets = isPaginated ? newAssets.get('results') : newAssets;
      // @ts-expect-error `newAssets` is unknown
      const newHasMore = isPaginated ? newAssets.get('hasMore') : false;

      // TODO: Try to fix this in r-r so we don't have a special case
      const newOffset = referenceObjectType === ReferenceObjectTypes.CTA ?
      // @ts-expect-error `newAssets` is unknown
      newAssets.get('offset') + parsedAssets.size :
      // @ts-expect-error `newAssets` is unknown
      newAssets.get('offset');
      const data = parsedAssets.filter(identity);
      const missingData = getMissingFields(assetFamily,
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '<T extends object | Iterable<any... Remove this comment to see the full error message
      indexBy(get('id'), List(parsedAssets)), getMissingFieldErrorMessage, ids);
      return {
        data,
        hasMore: newHasMore,
        isPaginated,
        missingData,
        offset: newOffset,
        queryChanged,
        updateImmediate: isPaginated
      };
    };
    if (isReferenceResolverSearch(resolver)) {
      if (ids) {
        const promises = ids.map(id => {
          return atomToPromise(resolver.byId(id));
        });
        return Promise.all(promises).then(fetchDataHandler);
      } else {
        return atomToPromise(resolver.search({
          // @ts-expect-error `hasMore` not recognized by `resolver.search`
          hasMore: actualHasMore,
          offset: actualOffset || 0,
          query: query || '',
          count: 100,
          listFilterProperties
        })).then(fetchDataHandler);
      }
    } else {
      if (resolver && typeof resolver.all !== 'function') {
        Raven.captureException(new Error(`[Expected a reference resolver] resolver does not have 'all' function; assetFamily: ${assetFamily}`));
      }
      return atomToPromise(resolver.all()).then(fetchDataHandler);
    }
  }
  formatData({
    data: newData,
    isHiddenFromSelect,
    isPaginated,
    missingData,
    queryChanged
  }, assetFamily, prevData) {
    const newDataWithMutations = getDataWithMutations(newData, assetFamily);
    const formattedNewData = isHiddenFromSelect ? toDSFieldRecord(newDataWithMutations, assetFamily).map(field => field.set('isHiddenFromSelect', true)) : toDSFieldRecord(newDataWithMutations, assetFamily);
    const formattedNewDataWithMissingData = formattedNewData.merge(missingData);
    if (isPaginated && queryChanged) {
      return prevData.map(field => field.set('isHiddenFromSelect', true)).merge(formattedNewDataWithMissingData);
    } else {
      return prevData.merge(formattedNewDataWithMissingData);
    }
  }
  clearCache(assetFamily, props) {
    const referenceObjectType = DSAssetFamilyToReferenceObjectType.get(assetFamily);
    resetLastQueries(referenceObjectType);
    const {
      referenceResolversByDSAssetFamily = {}
    } = props;
    const propertyGroupResolver = referenceResolversByDSAssetFamily[ReferenceObjectTypes.PROPERTY_GROUP];
    propertyGroupResolver === null || propertyGroupResolver === void 0 || propertyGroupResolver.refreshCache();
    const fetcher = this.getFetcher(assetFamily, props);
    fetcher === null || fetcher === void 0 || fetcher.refreshCache();
  }
  clearCacheAll() {
    resetLastQueriesAll();
  }
}
export default Adapter.makeFromConfig(ReferenceResolverAdapterConfig);
const defaultMergeResolvers = memoize((providedResolvers, connectedResolvers) => {
  if (!connectedResolvers) {
    return providedResolvers;
  }
  return Object.assign({}, providedResolvers, connectedResolvers);
});
const mergeResolvers = (providedResolvers, connectedResolvers, props) => {
  if (props.mergeResolvers) {
    return props.mergeResolvers(providedResolvers, connectedResolvers, props);
  }
  return defaultMergeResolvers(providedResolvers, connectedResolvers);
};
const mapResolversToProps = resolvers => ({
  resolvers: ImmutableMap(resolvers),
  referenceResolversByDSAssetFamily: DSAssetFamilyToReferenceObjectType.map(referenceObjectType => resolvers[referenceObjectType]).toJS()
});
export const configureComponent = Component => {
  const connectedComponent = ConnectReferenceResolvers(mapResolversToProps, Component);
  return ProvideReferenceResolvers(resolversMap, connectedComponent, {
    mergeResolvers
  });
};